export const isNumberAndNotIncludesPlus = (value: string) =>
  !Number.isNaN(Number.parseInt(value, 10)) && !value.endsWith('+') && !value.startsWith('+');
